/** stok (inventory) copy. Keys are flat, dot-namespaced and stable; placeholders use {name}. */
export const enStok = {
  // ---- Navigation -----------------------------------------------------------------------
  'stok.nav.stock': 'Stock',
  'stok.nav.replenishment': 'Planning',
  'stok.nav.group.purchasing': 'Purchasing',
  'stok.nav.group.operations': 'Operations',
  'stok.nav.valuation': 'Valuation',
  'stok.nav.movements': 'Movements',
  'stok.nav.opening': 'Opening balance',
  'stok.nav.lots': 'Lots & expiry',
  'stok.nav.receipts': 'Receiving',
  'stok.nav.purchaseOrders': 'Purchase orders',
  'stok.nav.sourcing': 'Quotes & agreements',
  'stok.nav.suppliers': 'Suppliers',
  'stok.nav.waste': 'Waste',
  'stok.nav.counts': 'Stock counts',
  'stok.nav.masterData': 'Master data',
  'stok.nav.masterDataLabel': 'Master data sections',
  'stok.nav.purchaseRequests': 'Purchase requests',
  'stok.nav.transfers': 'Transfers',
  'stok.nav.consumption': 'Consumption',
  'stok.nav.recalls': 'Recalls',
  'stok.nav.lotsSections': 'Lot sections',
  'stok.nav.countsSections': 'Stock count sections',
  'stok.nav.countAccuracy': 'Accuracy',
  'stok.nav.items': 'Items',
  'stok.nav.locations': 'Locations',

  // ---- Supplier sourcing ---------------------------------------------------------------
  'stok.sourcing.title': 'Supplier sourcing',
  'stok.sourcing.subtitle': 'Compare like-for-like net prices and keep the commercial evidence.',
  'stok.sourcing.rfqs': 'Requests for quotation',
  'stok.sourcing.rfqsDesc': 'Issue a request, record supplier responses, and document the award.',
  'stok.sourcing.newRfq': 'New RFQ',
  'stok.sourcing.titleField': 'Request title',
  'stok.sourcing.purpose': 'Purpose',
  'stok.sourcing.due': 'Response due',
  'stok.sourcing.catalogue': 'Supplier item catalogue',
  'stok.sourcing.catalogueDesc':
    'Map each supplier pack to an inventory item before recording terms.',
  'stok.sourcing.addSupplierItem': 'Add supplier item',
  'stok.sourcing.addAgreement': 'Add agreement',
  'stok.sourcing.supplierSku': 'Supplier SKU',
  'stok.sourcing.purchaseUnit': 'Purchase unit',
  'stok.sourcing.leadTime': 'Lead time (days)',
  'stok.sourcing.tax': 'Tax basis',
  'stok.sourcing.taxExclusive': 'Tax exclusive',
  'stok.sourcing.taxInclusive': 'Tax inclusive',
  'stok.sourcing.taxExempt': 'Tax exempt',
  'stok.sourcing.taxRate': 'Tax rate (%)',
  'stok.sourcing.reference': 'Reference',
  'stok.sourcing.validFrom': 'Valid from',
  'stok.sourcing.validTo': 'Valid to',
  'stok.sourcing.unitPrice': 'Unit price',
  'stok.sourcing.normalized': 'Normalized net price',
  'stok.sourcing.currentTerms': 'Commercial terms',
  'stok.sourcing.noRfqs': 'No RFQs yet.',
  'stok.sourcing.noCatalogue': 'No supplier item mappings yet.',
  'stok.sourcing.noTerms': 'No quote or agreement history yet.',
  'stok.sourcing.saved': 'Commercial record saved.',
  'stok.sourcing.created': 'RFQ {number} created.',
  'stok.sourcing.open': 'Open RFQ {number}',
  'stok.sourcing.openLabel': 'Open',
  'stok.rfq.issue': 'Issue RFQ',
  'stok.rfq.quote': 'Record quote',
  'stok.rfq.award': 'Award supplier',
  'stok.rfq.comparison': 'Normalized comparison',
  'stok.rfq.comparisonDesc': 'Prices exclude inclusive tax and use each item’s display unit.',
  'stok.rfq.total': 'Comparable total',
  'stok.rfq.validity': 'Validity',
  'stok.rfq.complete': 'Complete',
  'stok.rfq.incomplete': 'Missing lines',
  'stok.rfq.expired': 'Expired or not active',
  'stok.rfq.reason': 'Award reason',
  'stok.rfq.issued': 'RFQ issued.',
  'stok.rfq.quoted': 'Supplier quote recorded.',
  'stok.rfq.awarded': 'Supplier awarded.',
  'stok.rfq.lines': 'Requested items',
  'stok.rfq.back': 'Back to quotes and agreements',
  'stok.rfq.awardReasonHint':
    'Explain price, quality, lead time, pack size, or another deciding factor.',

  // ---- Shared ---------------------------------------------------------------------------
  'stok.csv': 'Export CSV',
  'stok.perUnit': 'per {unit}',
  'stok.state.refreshing': 'Updating…',
  'stok.state.stale': 'Could not refresh — the data shown may be out of date.',
  'stok.reason.invalid': 'Write between {min} and {max} characters.',
  'stok.badge.lot': 'Lot',
  'stok.badge.expiry': 'Expiry',
  'stok.form.name': 'Name',
  'stok.form.nameRequired': 'Enter a name.',
  'stok.form.tooLong': 'Use at most {max} characters.',
  'stok.form.sortOrder': 'Sort order',
  'stok.form.sortOrderHint': 'Lower numbers come first.',
  'stok.form.sortInvalid': 'Enter a whole number (0 or more).',
  'stok.unit.base.g': 'Gram (shown in kg)',
  'stok.unit.base.ml': 'Millilitre (shown in l)',
  'stok.unit.base.pcs': 'Piece (pcs)',
  'stok.unit.shownIn': 'shown in {unit}',
  'stok.unit.pack': '{name} · {qty}',
  'stok.col.sku': 'SKU',
  'stok.col.item': 'Item',
  'stok.col.category': 'Category',
  'stok.col.qty': 'Quantity',
  'stok.col.value': 'Value',
  'stok.col.avgCost': 'Average cost',
  'stok.col.unit': 'Unit',
  'stok.col.reorderPoint': 'Reorder point',
  'stok.col.reorder': 'Reorder status',
  'stok.col.location': 'Location',
  'stok.col.lot': 'Lot',
  'stok.col.type': 'Movement type',
  'stok.col.postedAt': 'Posted at',
  'stok.col.postedBy': 'Posted by',
  'stok.col.source': 'Source',
  'stok.col.date': 'Date',
  'stok.col.businessDate': 'Business date',
  'stok.col.sourceId': 'Source ID',
  'stok.col.reason': 'Reason',
  'stok.col.movementCount': 'Movements',
  'stok.col.status': 'Status',
  'stok.col.actions': 'Actions',

  // ---- Filters --------------------------------------------------------------------------
  'stok.filter.title': 'Filter',
  'stok.filter.location': 'Location',
  'stok.filter.allLocations': 'All locations',
  'stok.filter.search': 'Search',
  'stok.filter.searchPlaceholder': 'SKU, name or category',
  'stok.filter.allItems': 'All items',
  'stok.filter.allTypes': 'All types',
  'stok.filter.allCategories': 'All categories',
  'stok.filter.allReorder': 'All reorder statuses',
  'stok.filter.allStatuses': 'All statuses',
  'stok.filter.allUnits': 'All base units',
  'stok.filter.allTracking': 'All tracking',
  'stok.filter.allReasons': 'All reasons',
  'stok.filter.allCreators': 'All recorders',
  'stok.filter.allSuppliers': 'All suppliers',
  'stok.filter.allKinds': 'All kinds',
  'stok.filter.allTerms': 'All payment terms',
  'stok.filter.supplier': 'Supplier',
  'stok.filter.from': 'From',
  'stok.filter.to': 'To',
  'stok.filter.reset': 'Reset filter',
  'stok.filter.rangeOrder': 'The start date must not be after the end date.',
  'stok.filter.rangeIncomplete': 'Enter complete dates.',

  // ---- Reorder --------------------------------------------------------------------------
  'stok.reorder.below': 'Below reorder point',
  'stok.reorder.ok': 'Sufficient',
  'stok.reorder.none': 'No reorder point',
  'stok.reorder.point': 'Reorder at {qty}',

  // ---- Stock on hand --------------------------------------------------------------------
  'stok.stock.title': 'Stock on hand',
  'stok.stock.subtitle': 'Quantity and value per item in {branch}.',
  'stok.stock.total': 'Total stock value',
  'stok.stock.totalAtLocation': 'Stock value at {location}',
  'stok.stock.totalDesc': 'Weighted average cost, in {currency}.',
  'stok.stock.asOf': 'As of {time}',
  'stok.stock.itemCount': 'Items',
  'stok.stock.itemCountDesc': 'Active items, and inactive ones still holding stock.',
  'stok.stock.belowCount': 'Below reorder point',
  'stok.stock.belowCountDesc': 'Branch quantity under the item’s reorder point.',
  'stok.stock.listTitle': 'Items',
  'stok.stock.listDesc':
    'Branch quantity with the split per location. Value is the exact weighted-average pool.',
  'stok.stock.listDescLocation':
    'Quantity at this location. Value = quantity × branch average cost (derived).',
  'stok.stock.locationQty': '{location}: {qty}',
  'stok.stock.perLocation': 'Quantity of {item} per location',
  'stok.stock.emptyNoItems': 'No inventory items yet — create items first.',
  'stok.stock.emptyItemsLink': 'Open Items',
  'stok.stock.emptyNoStock':
    'No stock recorded yet. Stock enters through posted documents — start with the opening balance.',
  'stok.stock.emptyLink': 'Record opening balance',
  'stok.stock.noMatch': 'No items match “{query}”.',

  // ---- Valuation ------------------------------------------------------------------------
  'stok.valuation.title': 'Inventory valuation',
  'stok.valuation.subtitle': 'Stock value of {branch} at a point in time, from the stock ledger.',
  'stok.valuation.cutoffTitle': 'Cutoff',
  'stok.valuation.cutoffDesc':
    'Every movement posted up to this time counts. Time in the branch time zone ({timeZone}).',
  'stok.valuation.asOf': 'Value as of',
  'stok.valuation.now': 'Now',
  'stok.valuation.total': 'Total value',
  'stok.valuation.totalDesc': 'Sum of posted movement values, in {currency}.',
  'stok.valuation.method': 'Valuation method',
  'stok.valuation.methodDesc': 'Per branch and item.',
  'stok.valuation.methodWac': 'Weighted average (WAC)',
  'stok.valuation.itemCount': '{count} items with stock or value',
  'stok.valuation.reconciliation': 'Reconciliation',
  'stok.valuation.reconciliationDesc': 'Ledger total compared with the live cost pools.',
  'stok.valuation.reconciled': 'Reconciled',
  'stok.valuation.notReconciled': 'Difference',
  'stok.valuation.difference': 'Difference:',
  'stok.valuation.reconciliationNowOnly': 'Only checked for the current time. Choose “Now”.',
  'stok.valuation.byCategory': 'By category',
  'stok.valuation.byCategoryDesc': 'Value per item category.',
  'stok.valuation.noCategory': 'No category',
  'stok.valuation.rowsTitle': 'Per item',
  'stok.valuation.rowsDesc': 'Highest value first. Average cost per kg, litre or piece.',
  'stok.valuation.empty': 'No stock value at this time — values appear once stock is posted.',
  'stok.valuation.definitions': 'Definitions',
  'stok.valuation.definitionsDesc': 'How the figures are calculated, as returned by the server.',
  'stok.valuation.definitionsNone': 'No definitions returned.',
  'stok.valuation.def.method': 'Method',
  'stok.valuation.def.value': 'Value',
  'stok.valuation.def.quantity': 'Quantity',
  'stok.valuation.def.averageCost': 'Average cost',
  'stok.valuation.def.reconciliation': 'Reconciliation',
  'stok.valuation.historyTitle': 'Closing value, last {days} days',
  'stok.valuation.historyDesc': 'Per business day: value in, value out and closing value.',
  'stok.valuation.openingValue': 'Value before this period:',
  'stok.valuation.inbound': 'In',
  'stok.valuation.outbound': 'Out',
  'stok.valuation.closing': 'Closing value',

  // ---- Movements ------------------------------------------------------------------------
  'stok.movements.title': 'Stock movements',
  'stok.movements.subtitle':
    'The stock ledger of {branch}, newest first. Entries are never edited — corrections are reversals.',
  'stok.movements.listTitle': 'Ledger',
  'stok.movements.listDesc': 'Quantity and value change per movement (+ in, − out).',
  'stok.movements.loadedNote':
    'Search, sorting and export cover the movements loaded so far — load more to include older ones.',
  'stok.movements.searchPlaceholder': 'Item, SKU, lot, location or source',
  'stok.movements.businessDate': 'Business date {date}',
  'stok.movements.reversal': 'Reversal',
  'stok.movements.empty': 'No stock movements yet — they appear once stock is posted.',
  'stok.movements.emptyFiltered': 'No movements match this filter.',
  'stok.movements.loadMore': 'Load more',
  'stok.movements.end': 'End of the ledger.',
  'stok.type.opening': 'Opening balance',
  'stok.type.receipt': 'Receipt',
  'stok.type.consumption': 'Consumption',
  'stok.type.waste': 'Waste',
  'stok.type.adjustment': 'Adjustment',
  'stok.type.count': 'Stock count',
  'stok.type.transfer_out': 'Transfer out',
  'stok.type.transfer_in': 'Transfer in',
  'stok.type.supplier_return': 'Supplier return',
  'stok.type.revaluation': 'Revaluation',
  'stok.source.opening_balance': 'Opening balance',

  // ---- Opening balance ------------------------------------------------------------------
  'stok.opening.title': 'Opening balance',
  'stok.opening.subtitle': 'Record the starting stock and its cost at a location in {branch}.',
  'stok.opening.readOnly': 'Your role can view stock but not post opening balances.',
  'stok.opening.noPermission':
    'Posting an opening balance needs the stock adjustment permission. Ask a manager.',
  'stok.opening.noItems': 'No active items yet — create items before recording stock.',
  'stok.opening.noLocations': 'No active location yet — create a location first.',
  'stok.opening.headTitle': 'Location',
  'stok.opening.headDesc': 'All lines are posted to this location in one document.',
  'stok.opening.reason': 'Note',
  'stok.opening.reasonHint': 'For example: “Stock take at go-live”.',
  'stok.opening.linesTitle': 'Lines',
  'stok.opening.linesDesc': 'One line per item (per lot for lot-tracked items), up to {max}.',
  'stok.opening.lineLabel': 'Line {n}',
  'stok.opening.removeLine': 'Remove line {n}',
  'stok.opening.pickItem': 'Choose an item…',
  'stok.opening.qty': 'Quantity',
  'stok.opening.unit': 'Unit',
  'stok.opening.cost': 'Cost per {unit} ({currency})',
  'stok.opening.costHint': 'Digits only, in minor units — for IDR that is rupiah.',
  'stok.opening.lot': 'Lot code',
  'stok.opening.expiry': 'Expiry date',
  'stok.opening.shelfLifeHint': 'Shelf life: {days} days.',
  'stok.opening.inBase': 'Equals',
  'stok.opening.lineValue': 'Line value',
  'stok.opening.addLine': 'Add line',
  'stok.opening.total': 'Total value',
  'stok.opening.onceNote':
    'An opening balance can be posted only once per item and location; later corrections use a stock count.',
  'stok.opening.review': 'Review and post',
  'stok.opening.confirmTitle': 'Post the opening balance?',
  'stok.opening.confirmBody': '{count} lines will be posted to {location}.',
  'stok.opening.confirmWarning':
    'Posted movements cannot be edited. Check the quantities, units and costs.',
  'stok.opening.confirm': 'Post',
  'stok.opening.posting': 'Posting…',
  'stok.opening.posted': 'Opening balance posted ({count} movements).',
  'stok.opening.resultTitle': 'Opening balance posted',
  'stok.opening.resultDesc': 'These movements are now in the stock ledger.',
  'stok.opening.viewLedger': 'View movements',
  'stok.opening.err.location': 'Choose a location.',
  'stok.opening.err.reason': 'Use at most 200 characters.',
  'stok.opening.err.noLines': 'Add at least one line.',
  'stok.opening.err.tooManyLines': 'Use at most 100 lines per document.',
  'stok.opening.err.item': 'Choose an item.',
  'stok.opening.err.qty': 'Enter a quantity above 0 (at most 3 decimals).',
  'stok.opening.err.unit': 'Choose a unit for this item.',
  'stok.opening.err.precision': 'This quantity cannot be converted exactly — use a smaller unit.',
  'stok.opening.err.cost': 'Enter the cost in digits (0 or more).',
  'stok.opening.err.tooLarge': 'This line value is too large.',
  'stok.opening.err.lot': 'Enter the lot code.',
  'stok.opening.err.lotLength': 'Use at most 40 characters.',
  'stok.opening.err.expiry': 'Enter the expiry date.',
  'stok.opening.err.duplicate': 'This item (and lot) is already on another line.',
  'stok.opening.err.hasMovements':
    'This item already has movements at this location — use a stock count instead.',
  'stok.opening.err.lotExpiryConflict': 'This lot already exists with another expiry date.',

  // ---- Items ----------------------------------------------------------------------------
  'stok.items.title': 'Items',
  'stok.items.subtitle': 'Inventory items are shared by every branch of the business.',
  'stok.items.readOnly': 'Only roles that manage inventory for the whole business can edit items.',
  'stok.items.add': 'Add item',
  'stok.items.listTitle': 'Inventory items',
  'stok.items.listDesc': 'Base unit, tracking, reorder point and pack units.',
  'stok.items.empty': 'No items yet — add the ingredients and goods you keep in stock.',
  'stok.items.emptyReadOnly': 'No items yet — a manager adds them.',
  'stok.items.baseUnit': 'Base unit',
  'stok.items.baseUnitHint': 'Stock is kept in this unit. It cannot change later.',
  'stok.items.baseUnitLocked': 'The base unit cannot change after creation.',
  'stok.items.tracking': 'Tracking',
  'stok.items.trackingNone': 'Not tracked',
  'stok.items.trackingLot': 'Lot',
  'stok.items.trackingLotExpiry': 'Lot and expiry',
  'stok.items.reorderPoint': 'Reorder point',
  'stok.items.reorderPointIn': 'Reorder point ({unit}, optional)',
  'stok.items.reorderPointHint': 'Shown as “below reorder point” when branch stock drops under it.',
  'stok.items.packUnits': 'Pack units',
  'stok.items.editNamed': 'Edit {name}',
  'stok.items.createTitle': 'New item',
  'stok.items.editTitle': 'Edit item',
  'stok.items.formDesc': 'Master data for every branch.',
  'stok.items.skuHint': 'Letters, digits, dot, dash and underscore.',
  'stok.items.shelfLife': 'Shelf life in days',
  'stok.items.shelfLifeHint': 'Helps when entering expiry dates.',
  'stok.items.lotTracked': 'Track lots',
  'stok.items.lotTrackedHint': 'Every receipt and opening balance names a lot code.',
  'stok.items.expiryTracked': 'Track expiry dates',
  'stok.items.expiryTrackedHint': 'Each lot carries an expiry date. Needs lot tracking.',
  'stok.items.active': 'Active',
  'stok.items.activeHint': 'Inactive items cannot receive new stock.',
  'stok.items.createSubmit': 'Create item',
  'stok.items.saved': '{name} saved.',
  'stok.items.err.skuRequired': 'Enter a SKU.',
  'stok.items.err.skuFormat': 'Use letters, digits, dot, dash or underscore only.',
  'stok.items.err.skuTaken': 'An item with this SKU already exists.',
  'stok.items.err.shelfLife': 'Enter whole days from 1 to 3650.',
  'stok.items.err.reorderPoint': 'Enter a quantity of 0 or more (dot or comma for decimals).',
  'stok.items.err.expiryNeedsLot': 'Expiry tracking needs lot tracking.',
  'stok.items.err.lotLocked': 'Lot tracking cannot change after stock has been posted.',

  // ---- Pack units -----------------------------------------------------------------------
  'stok.units.title': 'Pack units',
  'stok.units.desc':
    'Units this item is bought or counted in, e.g. a 25 kg sack. Always available: g/kg, ml/l or pcs. Shown in {unit}.',
  'stok.units.empty': 'No pack units yet.',
  'stok.units.factor': '1 {unit} = {qty}',
  'stok.units.code': 'Code',
  'stok.units.contains': 'Contains',
  'stok.units.add': 'Add unit',
  'stok.units.added': 'Unit {name} added.',
  'stok.units.activate': 'Activate',
  'stok.units.deactivate': 'Deactivate',
  'stok.units.activateNamed': 'Activate unit {name}',
  'stok.units.deactivateNamed': 'Deactivate unit {name}',
  'stok.units.activated': 'Unit activated.',
  'stok.units.deactivated': 'Unit deactivated.',
  'stok.units.err.code': 'Use 1–12 lower-case letters, digits, dash or underscore.',
  'stok.units.err.standard': 'This is a standard unit — it is always available.',
  'stok.units.err.codeTaken': 'This item already has a unit with this code.',
  'stok.units.err.factor': 'Enter a quantity above 0 that converts exactly.',

  // ---- Locations ------------------------------------------------------------------------
  'stok.locations.title': 'Locations',
  'stok.locations.subtitle': 'Where stock is kept in {branch}.',
  'stok.locations.readOnly': 'Your role can view locations but not change them.',
  'stok.locations.add': 'Add location',
  'stok.locations.listTitle': 'Stock locations',
  'stok.locations.listDesc': 'The default location is preselected on stock documents.',
  'stok.locations.searchPlaceholder': 'Code, name or kind',
  'stok.locations.empty': 'No locations yet — add the store room first.',
  'stok.locations.emptyReadOnly': 'No locations yet — a manager adds them.',
  'stok.locations.code': 'Code',
  'stok.locations.codeHint': 'Upper-case letters, digits and dash, e.g. GDG. Cannot change later.',
  'stok.locations.codeLocked': 'The code cannot change after creation.',
  'stok.locations.kind': 'Kind',
  'stok.locations.default': 'Default',
  'stok.locations.defaultBadge': 'Default',
  'stok.locations.defaultName': '{name} (default)',
  'stok.locations.inactiveName': '{name} (inactive)',
  'stok.locations.defaultLabel': 'Default location',
  'stok.locations.defaultHint':
    'Replaces the current default. To change it, choose another default.',
  'stok.locations.activeLabel': 'Active',
  'stok.locations.activeHint': 'Only empty locations can be deactivated; the default cannot.',
  'stok.locations.editNamed': 'Edit {name}',
  'stok.locations.createTitle': 'New location',
  'stok.locations.editTitle': 'Edit location',
  'stok.locations.formDesc': 'A store room, kitchen, bar or other place that holds stock.',
  'stok.locations.createSubmit': 'Create location',
  'stok.locations.saved': '{name} saved.',
  'stok.locations.err.code': 'Use 1–12 upper-case letters, digits or dashes.',
  'stok.locations.err.codeTaken': 'A location with this code already exists.',
  'stok.locations.err.hasStock': 'Move or count out the stock before deactivating this location.',
  'stok.locations.err.defaultInactive': 'The default location cannot be deactivated.',
  'stok.locations.err.keepDefault': 'Choose another default location instead.',
  'stok.kind.storage': 'Store room',
  'stok.kind.kitchen': 'Kitchen',
  'stok.kind.bar': 'Bar',
  'stok.kind.other': 'Other',
  'stok.kind.quarantine': 'Quarantine',
} as const;
